import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Below Median' },
    { value: 1, label: 'At Median' },
    { value: 2, label: 'Beyond Median' },
    { value: 3, label: 'Not Included' },
  ],
});
